import React from "react"
/* Breadcrumbs */
import Typography from '@material-ui/core/Typography';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Link from '@atoms/Link';



export default (props) => {
 return(
    <Breadcrumbs aria-label="breadcrumb" style={{  margin: '15px 0'}}>
      <Link color="inherit" to="/" >
        الصفحة الرئيسية 
      </Link>
      <Typography color="textPrimary"> {props.page} </Typography>
    </Breadcrumbs>
 )
}